export function ViewListIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='18' height='14' viewBox='0 0 18 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1 1H17M1 5H17M1 9H17M1 13H17'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
